import DemoProject from "../../assets/svg/DemoProject.svg";
import CreateProject from "../../assets/svg/CreateProjectIcon.svg";
import CreateProjectForm from "@/components/project/CreateProjectForm";
import { useState } from "react";
import { useUser } from "@/hooks/useUser";
import useCreateDemoProjectQuary from "@/api/query/useCreateDemoProjectQuary";
import { useNavigate } from "react-router-dom";
import useProjectQuery from "@/api/query/useProjectQuery";
import { UserRoleEnumValue } from "@backend/src/schemas/enums";
import NoTaskImage from "../../assets/png/NoSearchTask.png";
import { useTranslation } from "react-i18next";
import Loader from "../common/Loader";
import Spinner from "../ui/spinner";
function NoProject() {
  const [open, setOpen] = useState<boolean>(false);
  const close = () => {
    setOpen(false);
  };
  const { t } = useTranslation();
  const { user } = useUser();
  const projectQuery = useProjectQuery();
  const CreateDemoProject = useCreateDemoProjectQuary(
    localStorage.getItem("organisation-id") + ""
  );
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const createDemoProjectSubmit = () => {
    setIsLoading(true);
    CreateDemoProject.refetch().then(() => {
      projectQuery.refetch().then((res) => {
        navigate("/tasks/" + res.data?.data.data[0].projectId);
      });
      setIsLoading(false);
    });
  };
  // useEffect(() => {
  //   createDemoProjectSubmit()
  // }, [])
  
  return (
    <>
      <div
        className={`w-full px-5 h-full flex flex-col overflow-auto justify-center items-center mt-5`}
      >
        {projectQuery.isRefetching && (
          <Loader className="absolute top-0 left-0 h-full w-full" />
        )}
        {!user?.userOrganisation[0]?.role && (
          <div className="flex flex-col m-auto justify-center items-center gap-24">
            <div className="p-6">
              <img src={NoTaskImage} className="w-96" />
            </div>
            <div className="lg:flex justify-between gap-x-5 w-full">
              <div>
                <span className="text-gray-400 text-2xl sm:text-3xl font-medium font-['Poppins']">
                  {t("don't_have_project")}
                  <br />
                </span>
                <span className="text-neutral-600 text-xl font-bold">
                  {t("ask_admin_to_assign")}
                </span>
              </div>
            </div>
          </div>
        )}
        {user?.userOrganisation[0]?.role == UserRoleEnumValue.ADMINISTRATOR && (
          <div className="flex flex-col gap-5 h-full w-full">
            {/* <div className="flex gap-2 items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
              <div className="relative w-40 h-8 bg-gray-450 organizationStep flex justify-center items-center text-base font-bold leading-3 text-white  tracking-wider">
                {t("step")} 1
              </div>
              <div className="relative w-40 h-8 bg-primary-500 organizationStep organizationStepActive flex justify-center items-center text-base font-bold leading-3 text-white  tracking-wider">
                {t("step")} 2
              </div>
            </div> */}
            <div className="text-2xl md:text-4xl font-bold text-gray-900">
              {t("create_first_project")}
            </div>
            <div className="flex gap-10 h-full w-full justify-center items-center mb-20 ">
              <div className="w-64 relative">
                <div className="text-lg font-bold text-center text-gray-450">
                  {t("recommended_option")}
                </div>
                <div
                  className=" border rounded-2xl gap-1 p-4 py-5 shadow flex bg-primary-500 cursor-pointer flex-col justify-center items-center"
                  onClick={createDemoProjectSubmit}
                >
                  <div className="bg-primary-400/50 rounded-lg flex gap-2 p-4 px-5 flex-col items-center justify-center">
                    <div className="font-bold text-lg md:text-3xl text-white">
                      {t("demo")}
                    </div>
                    <img
                      src={DemoProject}
                      alt=""
                      className="h-[40px] w-[40px]"
                    />
                  </div>
                  <div className="text-center text-lg text-white md:text-xl">
                    {t("use_a_demo_project")}
                  </div>
                  <div className="text-center text-sm text-white ">
                    {t("use_a_demo_project_description")}
                  </div>
                </div>
                {isLoading && (
                  <div className="absolute top-0 left-0 h-full w-full bg-slate-50/30 ">
                    <div className="flex flex-col items-center justify-center h-full w-full">
                      <Spinner color="#fff" className="h-14 w-14 " />
                    </div>
                  </div>
                )}
                {isLoading && (
                  <div className="text-center text-sm">
                    {t("Creating demo projects...")}
                  </div>
                )}
              </div>
              <div className="w-64">
                <div className="text-lg font-bold text-center text-transparent select-none text-gray-450">
                  as
                </div>
                <div
                  onClick={() => (!isLoading ? setOpen(true) : "")}
                  className={` border rounded-2xl gap-1  p-4 py-5 shadow flex bg-white cursor-pointer flex-col justify-center items-center  ${
                    isLoading ? "!bg-gray-50/50 !shadow-none" : ""
                  }`}
                >
                  <div
                    className={`bg-primary-500/10 rounded-lg flex gap-2 p-4 px-3 flex-col items-center justify-center`}
                  >
                    <div className="font-normal text-lg md:text-3xl text-primary-500">
                      {t("create")}
                    </div>
                    <img
                      src={CreateProject}
                      alt=""
                      className="h-[40px] w-[40px] 
              "
                    />
                  </div>
                  <div className="text-center text-lg md:text-xl">
                    {t("use_a_create_project")}
                  </div>
                  <div className="text-center text-sm ">
                    {t("use_a_create_project_description")}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {open && <CreateProjectForm handleClosePopUp={close} />}
    </>
  );
}
export default NoProject;
